import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AsyncSelect from "react-select/async";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import PartyRoleList from "./PartyRoleList";

const EditPartyRole = ({ party_role_id, contractId, contract_term, party_id }) => {
    const [formData, setFormData] = useState({
        party: "",
        role: "",
        contract: contractId,
        comment: ""
    });

    const [hideshow, setHideShow] = useState(false)

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();
    const form = useRef();
    const checkBtn = useRef();
    const [role, setRole] = useState("");
    const [rolesList, setRolesList] = useState([]); // New state for dynamic roles

    // Fetch roles and initial party role data
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${API}company/companysettingsview/`, { headers: authHeader() });
                if (response.data.party_roles) {
                    const roles = response.data.party_roles.split(',').map(r => r.trim());
                    setRolesList(roles);
                }
            } catch (error) {
                console.error("Error fetching company settings:", error);
                toast.error("Failed to load party roles");
            }
        };

        const fetchPartyRole = async () => {
            try {
                const response = await axios.get(`${API}contracts/party-roles/${party_role_id}/`, { headers: authHeader() });
                if (response.data.success === 1) {
                    const data = response.data.response;
                    setFormData({
                        party: data.party || "",
                        role: data.role || "",
                        contract: contractId,
                        comment: data.comment || "",
                    });
                    setRole(data.role);
                    setSelectedValue(data.party);
                    setCustomer_id(data.party);
                    setCustomer_name(data.party_name);
                    reset({
                        selectedValue: data.party,
                    });
                } else {
                    toast.error("Failed to fetch Additional Parties details", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "light",
                    });
                }
            } catch (error) {
                toast.error("Error fetching Additional Parties details", {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });
            }
        };

        fetchRoles();
        fetchPartyRole();
    }, [party_role_id, contractId, reset]);

    const [selectedValue, setSelectedValue] = useState(null);
    const [inputvalue, setValue] = useState("");
    const [options, setOptions] = useState([]);
    const [customer_name, setCustomer_name] = useState("");

    const [customer_id, setCustomer_id] = useState("");

    const navigate = useNavigate();

    const loadOptions = async (inputValue) => {
        if (inputValue !== "") {
            const responseJSON = await axios.get(
                API +
                `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
                { headers: authHeader() }
            );
            return responseJSON.data.data;
        }
    };

    // useEffect(() => {
    //     axios
    //         .get(`${API}contracts/party-roles/${party_role_id}/`, { headers: authHeader() })
    //         .then((response) => {
    //             if (response.data.success === 1) {
    //                 const data = response.data.response;
    //                 setFormData({
    //                     party: data.party || "",
    //                     role: data.role || "",
    //                     contract_id: contractId,
    //                 });
    //                 setRole(response.data.response.role)
    //                 setSelectedValue(response.data.response.party);
    //                 setCustomer_id(response.data.response.party);
    //                 setCustomer_name(response.data.response.party_name);
    //                 reset({
    //                         selectedValue: response.data.response.party,
    //                     });


    //             } else {
    //                 toast.error("Failed to fetch Additional Parties details", {
    //                     position: "top-right",
    //                     autoClose: 1000,
    //                     hideProgressBar: false,
    //                     pauseOnHover: true,
    //                     draggable: true,
    //                     theme: "light",
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             toast.error("Error fetching Additional Parties details", {
    //                 position: "top-right",
    //                 autoClose: 1000,
    //                 hideProgressBar: false,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 theme: "light",
    //             });
    //         });
    // }, [party_role_id, contractId]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleRegister = (e) => {
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            formData.party = selectedValue
            formData.role = role

            axios
                .post(`${API}contracts/party-roles/${party_role_id}/update/`, formData, {
                    headers: authHeader(),
                })
                .then((response) => {
                    if (response.data.success === 1) {
                        toast.success("Additional Parties updated successfully", {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "light",
                        });
                        setTimeout(() => {
                            setHideShow(true); // Navigate back to the list
                        }, 1000);
                    } else {
                        toast.error(response.data.error || "Failed to update Party Role", {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "light",
                        });
                    }
                })
                .catch((error) => {
                    toast.error("Error updating Additional Parties", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "light",
                    });
                });
        }
    };

    const handelInputChange = (value) => {
        setValue(value);
    };

    const handelChange = (value) => {
        if (value === null) {
            setSelectedValue(value);
            reset({
                selectedValue: value,
            });

        } else {
            setSelectedValue(value.id);
            reset({
                selectedValue: value.id,

            });

        }
    };

    const loadInitialOptions = async () => {
        const responseJSON = await axios.get(
            API +
            `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
            { headers: authHeader() }
        );
        setOptions(responseJSON.data.data);
    };

    useEffect(() => {

        loadInitialOptions(customer_name);

    }, [customer_name]);

    const handleCancel = () => {
        setHideShow(true)
    }
    return (
        <>
            <ToastContainer />
            {hideshow === true ?
                <PartyRoleList id={contractId} party_id={party_id} />
                :
                <div className="row py-2">
                    <div className="col-md-12">
                        <div className="header pb-0 mt-2 mb-2">
                            <h5 className="mb-0">{t("Edit Party Role")}</h5>
                        </div>

                        <div className=" card">
                            <div className=" card-body mt-2">
                                <Form ref={form} method="POST" onSubmit={handleSubmit(handleRegister)}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-lg-12 col-form-label required">
                                                    {t("Party")}{" "}
                                                    <Tooltip
                                                        content={t("party_Tooltip")}
                                                    >
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <div className="col-lg-11">
                                                    <AsyncSelect
                                                        {...register("selectedValue", {
                                                            required: true,
                                                        })}
                                                        defaultOptions={options}
                                                        isClearable
                                                        options={options}
                                                        value={options.find(
                                                            (option) =>
                                                                option.id === selectedValue
                                                        )}
                                                        getOptionLabel={(e) =>
                                                            e.customer_name
                                                        }
                                                        getOptionValue={(e) => e.id}
                                                        loadOptions={loadOptions}
                                                        onInputChange={handelInputChange}
                                                        onChange={handelChange}
                                                        placeholder="Select a party"
                                                        name="selectedValue"
                                                    ></AsyncSelect>
                                                    <div className="invalid-feedback">
                                                        {errors.selectedValue &&
                                                            "Party is required"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label required">
                                                    {t("Role")}{" "}
                                                    <Tooltip content={t("Role_Tooltip")}>
                                                        <i className="fa fa-light fa-circle-info"></i>
                                                    </Tooltip>
                                                </label>
                                                <select
                                                    onChange={(e) => setRole(e.target.value)}
                                                    id="role"
                                                    value={role}
                                                    className="form-control"
                                                >
                                                    <option value="">{t("Select")}</option>
                                                    {rolesList.map((r) => (
                                                        <option key={r} value={r}>
                                                            {t(r)}
                                                        </option>
                                                    ))}
                                                    {/* <option value="GUARANTOR">{t("Guarantor")}</option>
                                            <option  value="INSURANCE_PROVIDER">{t("Insurance Provider")}</option>
                                            <option  value="PRIVATE_LABEL_HOLDER">{t("Private Label Holder")}</option> */}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="col-form-label">
                                                    {t("Comment")}
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    name="comment"
                                                    value={formData.comment}
                                                    onChange={handleChange}
                                                    placeholder="Enter comment"
                                                    rows={2}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="ms-auto my-auto mt-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mb-0"
                                                    onClick={() => handleCancel()}
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    {t("Cancel")}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary mb-0"
                                                >
                                                    {t("Save")}
                                                </button>
                                                <CheckButton
                                                    style={{ display: "none" }}
                                                    ref={checkBtn}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default EditPartyRole;